// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEpmMasterAllocationKeyMutationVariables = Types.Exact<{
  deleteEpmMasterAllocationKeyId: Types.Scalars['ID']['input'];
}>;

export type DeleteEpmMasterAllocationKeyMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEpmMasterAllocationKey'
>;

export const DeleteEpmMasterAllocationKeyDocument = /*#__PURE__*/ gql`
    mutation DeleteEpmMasterAllocationKey($deleteEpmMasterAllocationKeyId: ID!) {
  deleteEpmMasterAllocationKey(id: $deleteEpmMasterAllocationKeyId)
}
    `;
export type DeleteEpmMasterAllocationKeyMutationFn = Apollo.MutationFunction<
  DeleteEpmMasterAllocationKeyMutation,
  DeleteEpmMasterAllocationKeyMutationVariables
>;

/**
 * __useDeleteEpmMasterAllocationKeyMutation__
 *
 * To run a mutation, you first call `useDeleteEpmMasterAllocationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpmMasterAllocationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpmMasterAllocationKeyMutation, { data, loading, error }] = useDeleteEpmMasterAllocationKeyMutation({
 *   variables: {
 *      deleteEpmMasterAllocationKeyId: // value for 'deleteEpmMasterAllocationKeyId'
 *   },
 * });
 */
export function useDeleteEpmMasterAllocationKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEpmMasterAllocationKeyMutation,
    DeleteEpmMasterAllocationKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEpmMasterAllocationKeyMutation, DeleteEpmMasterAllocationKeyMutationVariables>(
    DeleteEpmMasterAllocationKeyDocument,
    options,
  );
}
export type DeleteEpmMasterAllocationKeyMutationHookResult = ReturnType<typeof useDeleteEpmMasterAllocationKeyMutation>;
export type DeleteEpmMasterAllocationKeyMutationOptions = Apollo.BaseMutationOptions<
  DeleteEpmMasterAllocationKeyMutation,
  DeleteEpmMasterAllocationKeyMutationVariables
>;
